import React from "react";
import Tile from "./Tile";
import { useState } from "react";
/*
struct=>
    {
    grow
        type:row/col/item
        children: type:row/col=>    [{child,grow,type}]
                  item=>            {type,caption,media,mediaType,grow,link}
    }
*/

const Tiles = ({ structure, root, onChange, preview }) => {
    const { type, grow, children } = structure || {};
    const [openMenu, setOpenMenu] = useState(root);

    const innerOnChange = (_structure, index) => {
        let _children = [...(children || [])];
        if (!_structure) {
            delete _children[index];
        } else if (_structure === "backward") {
            if (_children[index - 1]) {
                let t = _children[index - 1];
                _children[index - 1] = _children[index];
                _children[index] = t;
            }
        } else if (_structure === "forward") {
            if (_children[index + 1]) {
                let t = _children[index + 1];
                _children[index + 1] = _children[index];
                _children[index] = t;
            }
        } else if (_structure === "increase") {
            _children[index].grow += 0.1;
        } else if (_structure === "decrease") {
            _children[index].grow -= 0.1;
            _children[index].grow < 0 && (_children[index].grow = 0);
        } else {
            _children[index] = _structure;
        }
        onChange({ type, grow, children: _children.filter((c) => c) });
    };

    return (
        <div
            className={`relative !text-3xl border-2  border-red-500/70 hover:border-green-500 ${
                !preview ? "p-4" : ""
            } ${
                root ? "h-full w-full lg:p-10" : "max-w-full"
            } items-stretch gap-2 lg:gap-6 flex ${
                type === "row"
                    ? "flex-col lg:!flex-row "
                    : "flex-row lg:!flex-col"
            }`}
            style={{ flexGrow: grow }}
        >
            {children?.map(
                (child, index) =>
                    child &&
                    (child.type === "item" ? (
                        <Tile
                            preview={preview}
                            key={index}
                            tile={child}
                            onChange={(s) => innerOnChange(s, index)}
                        />
                    ) : (
                        <Tiles
                            preview={preview}
                            key={index}
                            structure={child}
                            onChange={(s) => innerOnChange(s, index)}
                        />
                    ))
            )}
            {(!root || (children || [])?.length == 0) && (
                <div
                    className='INDICATE absolute top-0 right-0 w-fit max-w-min  overflow-x-auto'
                    style={{ zIndex: 2 }}
                >
                    <div
                        onClick={(e) => setOpenMenu(!openMenu)}
                        className={`btn m-1 btn-${
                            openMenu
                                ? "error btn-sm"
                                : "primary bg-blue-600 btn-sm"
                        } btn-circle`}
                    >
                        <i
                            className={`ri-${
                                openMenu ? "close" : "menu"
                            }-line text-white`}
                        ></i>
                    </div>
                    {openMenu && (
                        <div className='bg-red-500/70 rounded-xl'>
                            <div className={`flex flex-row`}>
                                <div
                                    className=' btn btn-circle btn-sm m-1  text-lg ri-layout-column-line'
                                    onClick={(e) => {
                                        onChange({
                                            type,
                                            grow,
                                            children: [
                                                ...(children || []),
                                                {
                                                    type: "row",
                                                    grow: 1,
                                                    children: [],
                                                },
                                            ],
                                        });
                                    }}
                                ></div>
                                <div
                                    className='btn btn-circle btn-sm m-1  text-lg ri-layout-row-line'
                                    onClick={(e) => {
                                        onChange({
                                            type,
                                            grow,
                                            children: [
                                                ...(children || []),
                                                {
                                                    type: "col",
                                                    grow: 1,
                                                    children: [],
                                                },
                                            ],
                                        });
                                    }}
                                ></div>
                                <div
                                    className='btn btn-circle btn-sm m-1  text-lg ri-square-fill'
                                    onClick={(e) => {
                                        onChange({
                                            type,
                                            grow,
                                            children: [
                                                ...(children || []),
                                                {
                                                    type: "item",
                                                    grow: 1,
                                                    caption: "",
                                                    media: "",
                                                    mediaType: "image",
                                                    link: "",
                                                },
                                            ],
                                        });
                                    }}
                                ></div>
                                <div
                                    className=' btn btn-circle btn-sm m-1 ri-delete-bin-line text-red-500 text-lg'
                                    onClick={(e) => {
                                        onChange(null);
                                    }}
                                ></div>
                                {!root && (
                                    <>
                                        <div
                                            className=' btn btn-circle ri-arrow-right-line text-black-500 text-lg btn-sm m-1'
                                            onClick={(e) => {
                                                onChange("backward");
                                            }}
                                        ></div>
                                        <div
                                            className=' btn btn-circle ri-arrow-left-line text-black-500 text-lg btn-sm m-1'
                                            onClick={(e) => {
                                                onChange("forward");
                                            }}
                                        ></div>
                                    </>
                                )}
                            </div>

                            {!root && (
                                <div className={`flex flex-row items-center`}>
                                    <div
                                        className=' btn btn-circle ri-add-line text-black-500 text-lg btn-sm m-2'
                                        onClick={(e) => {
                                            onChange("increase");
                                        }}
                                    ></div>
                                    <div className='bg-black-700 text-white text-center items-center flex p-1 rounded-full h-fit'>
                                        {(
                                            parseFloat(
                                                parseInt(parseFloat(grow) * 10)
                                            ) / 10
                                        ).toString()}
                                    </div>
                                    <div
                                        className=' btn btn-circle ri-subtract-line text-black-500 text-lg btn-sm m-2'
                                        onClick={(e) => {
                                            onChange("decrease");
                                        }}
                                    ></div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Tiles;
